import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { resendWorkspaceEmailLogEntry } from '@/api/emailLog/emailLogApi';
import type { EmailLogEntryDetail } from '@/api/emailLog/emailLogApi.types';
import { WORKSPACE_EMAIL_LOG_QUERY_KEY } from '@/constants/queryKeys';

export function useResendEmailLogEntryMutation(): UseMutationResult<
  EmailLogEntryDetail,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resendWorkspaceEmailLogEntry,
    onSuccess: function refreshEmailLog() {
      queryClient.invalidateQueries({ queryKey: WORKSPACE_EMAIL_LOG_QUERY_KEY });
    },
  });
}
